import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useEffect, useState } from 'react';
import TableWithHeadingAndSearch from '../../components/Table/TableWithHeadingAndSearch';
import {
    fetchCustomers,
    fetchVendors,
    getCustomer,
    updateCustomer,
} from '../../app/reducers/Customer/customerSlice';
import { useMemo } from 'react';
import { ClipLoader } from 'react-spinners';
import { Clock, Edit2 } from 'react-feather';
// import EditCustomer from "./EditCustomer";
import { customIDs } from '../../utils/customIds';
import { openReminderPopUp } from '../../app/reducers/ReminderPopUp/reminderPopUpSlice';
import PhoneIconBox from '../../components/infrastructure/PhoneIconBox';
import TableWithHeadingAndGlobalSearch from '../../components/Table/TableWithHeadingAndGlobalSearch';
import PaginationClassic from '../../components/pagination/PaginationClassic';

const ViewVendors = () => {
    const dispatch = useDispatch();
    const { customer_calling } = customIDs;
    const [index, setIndex] = useState(0);
    const [page, setPage] = useState(0);
    const [editData, setData] = useState({});
    const [modalOpen, setModalOpen] = useState(false);
    const [loadingReminder, setLoadingReminder] = useState(false);

    useEffect(() => {
        dispatch(
            fetchVendors({
                contact_type: 'vendor',
                page,
            })
        );
    }, [page]);
    const { vendors, loading } = useSelector(getCustomer);

    const cols = [
        {
            Header: 'SRNO',
            Cell: ({ row, data }) => {
                return row.index + 1;
            },
        },
        {
            Header: 'Name',
            accessor: 'contact_name',
            Cell: ({ row }) => {
                return (
                    <div className="flex">
                        <PhoneIconBox
                            child={<span>{row?.original?.contact_name}</span>}
                            green
                            blue
                            obj={{ contact_id: row?.original?.contact_id }}
                        />
                    </div>
                );
            },
        },
        {
            Header: 'Company Name',
            accessor: 'company_name',
        },
        {
            Header: 'Action',
            Cell: ({ row }) => {
                return (
                    <>
                        {loadingReminder == row.original._id ? (
                            <ClockLoader size={25} speedMultiplier={2} />
                        ) : (
                            <button
                                onClick={async (e) => {
                                    e.stopPropagation();
                                    console.log('row', row.original);
                                    setLoadingReminder(row.original._id);
                                    let popUpData = {};
                                    popUpData['vendorMobileNo'] =
                                        row.original?.mobile;
                                    popUpData['vendor_name'] =
                                        row.original?.company_name;

                                    dispatch(
                                        openReminderPopUp({
                                            isOpen: true,
                                            data: {
                                                ...popUpData,
                                                type: 'vendor',
                                                reminderType: 'reminder',
                                                path: 'contacts',
                                                path_id:
                                                    row.original?.contact_id,
                                            },
                                        })
                                    );
                                    setLoadingReminder('');
                                }}
                            >
                                <Clock
                                    size={25}
                                    color={
                                        row.original?.cf_reminder == 'YES'
                                            ? '#ffff1a'
                                            : 'black'
                                    }
                                />
                            </button>
                        )}
                    </>
                );
            },
        },
    ];

    // console.log(custom)
    const vendorsData = useMemo(
        () => (vendors?.contacts ? vendors.contacts : []),
        [vendors]
    );

    const debouncedSearch = useCallback(
        _.debounce(async (search) => {
            dispatch(
                fetchVendors({
                    search: search,
                    page,
                })
            );
        }, 300),
        [page]
    );

    return (
        <>
            {/* <EditCustomer
        title={"Edit Contact"}
        setPurchaseModal={setModalOpen}
        viewPurchaseModal={modalOpen}
        data={editData}
      /> */}
            <div className="p-4" style={{ overflow: 'hidden' }}>
                {/* {loading ? (
                    <ClipLoader />
                ) : ( */}
                <TableWithHeadingAndGlobalSearch
                    heading={'Vendors'}
                    data={vendorsData}
                    loading={loading}
                    columns={cols}
                    searchFunction={debouncedSearch}
                />
                <PaginationClassic
                    paginationDetails={vendors}
                    setPage={setPage}
                />
                {/* )} */}
            </div>
        </>
    );
};

export default ViewVendors;
